"use strict";

var _slicedToArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _taggedTemplateLiteral = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js").default;
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var _ownKeys = function ownKeys(o) {
    _ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return _ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = _ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var d3_1 = require("d3");
var styled_components_1 = __importDefault(require("styled-components"));
var f = (0, d3_1.format)('.2%');
/** Default values if not passed into the component */
var defaults = {
  width: 500,
  height: 500,
  innerRadius: 0.7,
  outerRadius: 1,
  legend: true,
  colors: ['#52E3C2', '#5FC0F0', '#5194B9', '#AC5BBE', '#EFB068', '#F5DD50', '#EFB068', '#E1953C', '#459C8D', '#B65F57', '#F27362', '#E0E0E0'],
  textColor: '#FFF'
};
var Slice = function Slice(_ref) {
  var data = _ref.data,
    index = _ref.index,
    arcGen = _ref.arcGen,
    color = _ref.color,
    hovered = _ref.hovered,
    setHovered = _ref.setHovered;
  return react_1.default.createElement("g", {
    key: index,
    onMouseEnter: function onMouseEnter() {
      return setHovered(data.data.label);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(null);
    }
  }, react_1.default.createElement(StyledPath, {
    className: "arc ".concat(hovered === data.data.label ? 'hover' : ''),
    d: arcGen(data) || undefined,
    fill: color
  }));
};
var StyledPath = styled_components_1.default.path(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover,\n  &.hover {\n    transform: scale(1.04);\n  }\n  transition: transform 200ms;\n"])));
var Legend = function Legend(_ref2) {
  var data = _ref2.data,
    colors = _ref2.colors,
    textColor = _ref2.textColor,
    hovered = _ref2.hovered,
    setHovered = _ref2.setHovered;
  return react_1.default.createElement("div", {
    onMouseLeave: function onMouseLeave() {
      return setHovered(null);
    }
  }, data.map(function (_ref3, i) {
    var data = _ref3.data;
    return react_1.default.createElement(StyledLegendRow, {
      key: i,
      className: "".concat(hovered === data.label ? 'hover' : ''),
      onMouseEnter: function onMouseEnter() {
        return setHovered(data.label);
      },
      color: textColor
    }, react_1.default.createElement("div", {
      className: 'dot'
    }, react_1.default.createElement(StyledLegendColor, {
      color: colors[i]
    })), react_1.default.createElement("div", {
      className: 'label'
    }, data.label), react_1.default.createElement("div", {
      className: 'value'
    }, f(data.value)));
  }));
};
var StyledLegendRow = styled_components_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  border-radius: 1em;\n  margin: 2px 0;\n  padding: 0px 5px;\n  color: ", ";\n\n  div {\n    padding: 2px 5px;\n    &.label {\n      width: 100%;\n    }\n    &.value {\n      text-align: end;\n    }\n  }\n  &:hover,\n  &.hover {\n    background-color: var(--atom-brand-4);\n    font-weight: 700;\n    transition: font-weight 200ms;\n  }\n"])), function (_ref4) {
  var color = _ref4.color;
  return color;
});
/**
 * The AtomDonut is a standard donut chart with customizable inputs.
 * @param data An array of objects, with objects of type datum ({ label: string; value: number }).
 * @returns donut chart react component
 */
var AtomDonut = function AtomDonut(_ref5) {
  var symbol = _ref5.symbol,
    data = _ref5.data,
    _ref5$innerRadius = _ref5.innerRadius,
    innerRadius = _ref5$innerRadius === void 0 ? defaults.innerRadius : _ref5$innerRadius,
    _ref5$outerRadius = _ref5.outerRadius,
    outerRadius = _ref5$outerRadius === void 0 ? defaults.outerRadius : _ref5$outerRadius,
    _ref5$colors = _ref5.colors,
    colors = _ref5$colors === void 0 ? defaults.colors : _ref5$colors,
    _ref5$textColor = _ref5.textColor,
    textColor = _ref5$textColor === void 0 ? defaults.textColor : _ref5$textColor,
    _ref5$legend = _ref5.legend,
    legend = _ref5$legend === void 0 ? defaults.legend : _ref5$legend,
    _ref5$width = _ref5.width,
    width = _ref5$width === void 0 ? defaults.width : _ref5$width,
    _ref5$height = _ref5.height,
    height = _ref5$height === void 0 ? defaults.height : _ref5$height;
  var _ref6 = (0, react_1.useState)(null),
    _ref7 = _slicedToArray(_ref6, 2),
    hoveredLabel = _ref7[0],
    setHoveredLabel = _ref7[1];
  var _ref8 = (0, react_1.useState)(null),
    _ref9 = _slicedToArray(_ref8, 2),
    hoveredValue = _ref9[0],
    setHoveredValue = _ref9[1];
  var orientation = height > width ? 'vertical' : 'horizontal';
  var _ref0 = orientation === 'horizontal' ? [width / 2, height] : [width, height / 2],
    _ref1 = _slicedToArray(_ref0, 2),
    svgWidth = _ref1[0],
    svgHeight = _ref1[1];
  var smallerDimension = svgWidth < svgHeight ? svgWidth : svgHeight;
  var arcGen = (0, d3_1.arc)().innerRadius(innerRadius * smallerDimension / 2).outerRadius(outerRadius * smallerDimension / 2).padAngle(0.01);
  var pieGen = (0, d3_1.pie)().value(function (d) {
    return d.value;
  });
  var pieData = pieGen(data);
  var vizRef = (0, react_1.useRef)();
  (0, react_1.useEffect)(function () {
    var _a;
    if (hoveredLabel) setHoveredValue(((_a = data.find(function (d) {
      return d.label === hoveredLabel;
    })) === null || _a === void 0 ? void 0 : _a.value) || null);
  }, [data, hoveredLabel]);
  return react_1.default.createElement(StyledContainer, {
    ref: vizRef,
    orientation: orientation
  }, react_1.default.createElement(StyledSVGContainer, {
    orientation: orientation
  }, react_1.default.createElement(StyledSVG, {
    width: svgWidth,
    viewBox: "0 0 ".concat(svgWidth, " ").concat(svgHeight)
  }, react_1.default.createElement("g", {
    transform: "translate(".concat(svgWidth / 2, " ").concat(svgHeight / 2, ")")
  }, pieData.map(function (d, i) {
    return react_1.default.createElement(Slice, {
      key: i,
      data: d,
      index: i,
      arcGen: arcGen,
      color: colors[i],
      hovered: hoveredLabel,
      setHovered: setHoveredLabel
    });
  }))), hoveredValue && hoveredLabel ? react_1.default.createElement(StyledText, {
    left: svgWidth / 2,
    top: svgHeight / 2,
    color: textColor
  }, react_1.default.createElement("div", null, symbol), react_1.default.createElement(StyledSpan, null, f(hoveredValue)), react_1.default.createElement("div", null, hoveredLabel)) : react_1.default.createElement(StyledText, {
    left: svgWidth / 2,
    top: svgHeight / 2,
    color: textColor
  }, react_1.default.createElement(StyledSpan, null, symbol))), legend && react_1.default.createElement(StyledLegendContainer, {
    orientation: orientation
  }, react_1.default.createElement(Legend, {
    data: pieData,
    colors: colors,
    hovered: hoveredLabel,
    setHovered: setHoveredLabel,
    textColor: textColor
  })));
};
exports.default = react_1.default.memo(AtomDonut);
var StyledSVGContainer = styled_components_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  margin: ", ";\n"])), function (_ref10) {
  var orientation = _ref10.orientation;
  return orientation === 'vertical' ? '0' : 'auto';
});
var StyledText = styled_components_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  text-anchor: middle;\n  text-align: center;\n  transform: translate(-50%, -50%);\n  color: ", ";\n"])), function (_ref11) {
  var top = _ref11.top;
  return top;
}, function (_ref12) {
  var left = _ref12.left;
  return left;
}, function (_ref13) {
  var color = _ref13.color;
  return color;
});
var StyledSpan = styled_components_1.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 2em;\n  font-weight: 800;\n"])));
var StyledSVG = styled_components_1.default.svg(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  overflow: visible;\n"])));
var StyledContainer = styled_components_1.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: ", ";\n  width: 100%;\n  height: 100%;\n  justify-content: flex-start;\n"])), function (_ref14) {
  var orientation = _ref14.orientation;
  return orientation === 'horizontal' ? 'nowrap' : 'wrap';
});
var StyledLegendContainer = styled_components_1.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin: ", ";\n  width: 100%;\n  padding: 10px 0px;\n"])), function (_ref15) {
  var orientation = _ref15.orientation;
  return orientation === 'vertical' ? '0' : 'auto';
});
var StyledLegendColor = styled_components_1.default.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 5px;\n  background-color: ", ";\n"])), function (props) {
  return props.color;
});